(function () {
  'use strict';

  var DRAFT_KEY = 'etolie-return-draft-v2';

  function fallbackCopy(text) {
    var field = document.createElement('textarea');
    try {
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      return document.execCommand('copy');
    } catch (error) {
      return false;
    } finally {
      if (field.parentNode) field.parentNode.removeChild(field);
    }
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function () { return true; }).catch(function () {
        return fallbackCopy(text);
      });
    }
    return Promise.resolve(fallbackCopy(text));
  }

  class EtolieReturns extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.setupCopyButtons();
      this.setupDraft();
      this.setupAnchors();
      this.revealMessage();

      if (this.dataset.nativeReturns === 'false') {
        var fallback = this.querySelector('#ezw-return-fallback');
        if (fallback) fallback.open = true;
      }
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.copyStatusTimers) {
        this.querySelectorAll('.ezw__copy-status').forEach(function (status) {
          window.clearTimeout(this.copyStatusTimers.get(status));
        }, this);
      }
    }

    setupCopyButtons() {
      this.copyStatusTimers = this.copyStatusTimers || new WeakMap();
      var component = this;
      this.querySelectorAll('[data-copy-text]').forEach(function (button) {
        button.addEventListener('click', function () {
          var card = button.closest('.ezw__shipping-card');
          var status = card && card.querySelector('.ezw__copy-status');
          var german = document.documentElement.lang.split('-')[0] === 'de';
          var label = button.getAttribute('data-copy-label') || (german ? 'Wert' : 'Wartość');
          copyText(button.getAttribute('data-copy-text')).then(function (copied) {
            if (!status) return;
            window.clearTimeout(component.copyStatusTimers.get(status));
            status.textContent = copied
              ? (german ? 'Feld „' + label + '“ kopiert.' : 'Skopiowano pole „' + label + '”.')
              : (german ? 'Das Feld „' + label + '“ konnte nicht kopiert werden. Markiere den Wert bitte manuell.' : 'Nie udało się skopiować pola „' + label + '”. Zaznacz wartość ręcznie.');
            var timer = window.setTimeout(function () { status.textContent = ''; }, 3000);
            component.copyStatusTimers.set(status, timer);
          });
        }, { signal: this.signal });
      }, this);
    }

    setupDraft() {
      var form = this.querySelector('#etolie-return-form');
      var success = this.querySelector('#ezw-success');

      try {
        if (success) {
          window.sessionStorage.removeItem(DRAFT_KEY);
          return;
        }
        if (!form) return;

        var fields = form.querySelectorAll('input:not([type="hidden"]), select, textarea');
        var saved = JSON.parse(window.sessionStorage.getItem(DRAFT_KEY) || '{}');

        fields.forEach(function (field) {
          if (!field.value && saved[field.name]) field.value = saved[field.name];
        });

        var saveDraft = function () {
          var values = {};
          fields.forEach(function (field) { values[field.name] = field.value; });
          window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify(values));
        };

        form.addEventListener('input', saveDraft, { signal: this.signal });
        form.addEventListener('change', saveDraft, { signal: this.signal });
      } catch (error) {
        // Formularz pozostaje w pełni użyteczny, gdy pamięć sesji jest zablokowana.
      }
    }

    setupAnchors() {
      this.querySelectorAll('a[href^="#ezw-"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = this.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();

          var details = target.matches('details') ? target : target.closest('details');
          if (details) details.open = true;

          var focusTarget = target.matches('details') ? target.querySelector('[tabindex="-1"]') : target;
          window.setTimeout(function () {
            target.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start'
            });
            if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
          }, 0);
        }.bind(this), { signal: this.signal });
      }, this);
    }

    revealMessage() {
      var message = this.querySelector('#ezw-success') || this.querySelector('#ezw-errors');
      if (!message) return;

      var details = message.closest('details');
      if (details) details.open = true;
      window.setTimeout(function () { message.focus(); }, 0);
    }
  }

  if (!customElements.get('etolie-returns')) {
    customElements.define('etolie-returns', EtolieReturns);
  }
})();
